import type { MediaPlatform } from '@/types/media'
import { cn } from '@/lib/utils'

const platformConfig: Record<MediaPlatform, { label: string; className: string }> = {
  instagram: {
    label: 'Instagram',
    className:
      'bg-linear-to-br from-[#f58529] via-[#dd2a7b] to-[#833ab4] text-white shadow-[0_2px_8px_rgba(221,42,123,0.45)]',
  },
  youtube: {
    label: 'YouTube',
    className: 'bg-[#FF0000] text-white shadow-[0_2px_8px_rgba(255,0,0,0.35)]',
  },
  facebook: {
    label: 'Facebook',
    className: 'bg-[#1877F2] text-white shadow-[0_2px_8px_rgba(24,119,242,0.35)]',
  },
  vimeo: {
    label: 'Vimeo',
    className: 'bg-[#1AB7EA] text-white shadow-[0_2px_8px_rgba(26,183,234,0.35)]',
  },
}

const badgeBase =
  'inline-flex items-center rounded-full px-2 py-0.5 text-[9px] font-bold uppercase tracking-wide'

interface MediaVideoBadgesProps {
  platform: MediaPlatform | string
  category?: string | null
  className?: string
}

export function MediaVideoBadges({ platform, category, className }: MediaVideoBadgesProps) {
  const config = platformConfig[platform as MediaPlatform] ?? {
    label: platform,
    className: 'bg-neutral-800/90 text-white shadow-sm backdrop-blur-sm',
  }

  return (
    <div className={cn('flex flex-wrap gap-1.5', className)}>
      <span className={cn(badgeBase, config.className)}>{config.label}</span>
      {category ? (
        <span
          className={cn(
            badgeBase,
            'border border-white/50 bg-white/92 text-neutral-800 shadow-sm backdrop-blur-md',
          )}
        >
          {category}
        </span>
      ) : null}
    </div>
  )
}
